import _ from 'lodash';
import React from 'react';
import zoneCoordinateCalc from '../../utils/zoneCoordinateCalc';
import ballObj from '../../utils/ball/ballObj';

function PitchZoneChart({width, height, data}) {
    let calcData = zoneCoordinateCalc(width, height, data);
    let zoneX = width/5;
    let zoneY = width/5;

    const ballCodeObj = ballObj;

    return (
    <>
    <svg width={width+10} height={height+10}>
        <g transform='translate(5, 5)'>
            <rect width={width} height={height} fill={'none'} stroke={'#000000'} strokeWidth={'1px'}/>
        </g>
        <g transform={`translate(${5+zoneX},${5+zoneY})`}>
            <rect width={width*3/5} height={height*3/5} fill={'none'} stroke={'#CCCCCC'} strokeWidth={'1px'}/>
        </g>
        <g transform='translate(5, 5)'>
            {calcData.map((item, idx) => (
                item['pitchX'] &&
                <circle key={item['key']}
                cx={item['pitchX']}
                cy={item['pitchY']}
                fill={ballCodeObj[item['taggedPitchType']]['color']}
                stroke={ballCodeObj[item['taggedPitchType']]['strokeColor']}
                r="3"
                >
                </circle>
            ))}
        </g>
    </svg>
    </>
    )
}

export default PitchZoneChart;